import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../logo-total-energies.png';

const BG_IMAGES = ['/bg-1.jpeg', '/bg-2.jpeg', '/bg-3.png', '/bg-4.jpg'];
const SLIDE_INTERVAL = 6000;

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % BG_IMAGES.length);
    }, SLIDE_INTERVAL);
    return () => clearInterval(timer);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Slider de fond */}
      {BG_IMAGES.map((img, i) => (
        <div
          key={img}
          className={`login-bg-slide ${i === currentSlide ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        />
      ))}
      <div className="login-bg-overlay" />

      {/* Indicateurs du slider */}
      <div className="login-slider-dots">
        {BG_IMAGES.map((_, i) => (
          <button
            key={i}
            className={`login-dot ${i === currentSlide ? 'active' : ''}`}
            onClick={() => setCurrentSlide(i)}
          />
        ))}
      </div>

      <div className="login-card">
        <div className="login-header">
          <img src={logo} alt="TotalEnergies" style={{ width: 120, marginBottom: 16 }} />
          <h1>StationFlow</h1>
          <p>Gestion des Stations TotalEnergies Senegal</p>
        </div>
        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-error">{error}</div>}
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="votre@email.com" required />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mot de passe" required />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>
        <div style={{ marginTop: 20, fontSize: 12, color: '#999', textAlign: 'center' }}>
          Demo: admin@stationflow.com / Admin@2024
        </div>
      </div>
    </div>
  );
};

export default Login;
